import React from 'react'
import { observer } from 'mobx-react-lite'
import Checkbox from '@mui/material/Checkbox'
import { action } from 'mobx'
import { CustomTableStore, useCustomTableStore } from '../CustomTableStore'
import { CustomTableLocalRow } from '../CustomTableLocalRow'
import useCustomTableRenderLog from '../hooks/useCustomTableRenderLog'
import useStore from 'reusable/mobx-store-utils'

interface CustomTableCheckProps<RowData extends AnyObject, RowStore> {
   row: CustomTableLocalRow<RowData, RowStore>
}

export const CustomTableCheck = observer(function CustomTableCheck
   <RowData extends AnyObject, RowStore>(props: CustomTableCheckProps<RowData, RowStore>) {
   useCustomTableRenderLog('CustomTableCheck')
   const customTableStore = useCustomTableStore<CustomTableStore<RowData, RowStore>>()

   const localStore = useStore(
      sp => ({
         onClick: action((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            customTableStore.toggleRowSelection(sp.row)
            event.stopPropagation()
            event.preventDefault()
         }),
         get checkboxStyle(): React.CSSProperties {
            return { margin: '0px', padding: '0px', zIndex: 0 }
         },
      }),
      props
   )

   return (
      <Checkbox
         style={localStore.checkboxStyle}
         value={props.row.selected}
         checked={props.row.selected}
         onClick={localStore.onClick}
      />
   )
}
)
